<script lang="jsx">
  import { get } from 'lodash'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import parseChild from './parseChild'

  export default {
    name: 'TableTh',
    props: {
      column: Object,
      colIndex: Number,
      propScopedSlots: Object,
      borderStyle: {
        type: String,
        default: 'full',
      },
      align: {
        type: String,
        default: 'left',
      },
      size: {
        type: String,
        default: 'm',
      },
      hidden: {
        type: Boolean,
        default: false,
      },
    },
    render() {
      const props = this.$props
      const data = this.$attrs
      const fChild = this.$slots

      const cellData = get(props.column, 'title', fChild.default ? fChild.default() : null)
      let children = get(props.column, 'th.is', null)
      const thWidth = get(props.column, 'th.bs.width', null)
      const tdWidth = get(props.column, 'td.bs.width', null)

      const forwardData = {
        props: {
          cellData,
          ...props,
        },
      }

      children = parseChild(children, forwardData.props)
      let extraBs = {}
      const dynamicBs = get(props.column, 'th.getBs')
      if (dynamicBs) {
        extraBs = dynamicBs(forwardData.props)
      }

      return (
        <NewBsBox
          as="th"
          context={props}
          bs={{
            'cmp.table.thead': 'th',
            width: thWidth || tdWidth,
            ...get(props, 'column.th.bs', {}),
            ...extraBs,
          }}
          {...data}
        >
          {children}
        </NewBsBox>
      )
    },
  }
</script>
